import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Switch, FormControlLabel } from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import swal from "sweetalert2";
import { api } from "utils/Api"; // adjust path if needed
import { showWarning, showSuccess } from "utils/messageAlerts";

function CreateOrganizationPopup({ onClose, mode, organization, refreshOrganizations }) {
  const [name, setName] = useState("");
  const [organizationCode, setOrganizationCode] = useState("");
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  // const [assignedUserEmail, setAssignedUserEmail] = useState(null);

  useEffect(() => {
    if (mode === "edit" && organization) {
      setName(organization.name || "");
      setOrganizationCode(organization.organization_code || "");
      setDescription(organization.description || "");
      setEmail(organization.email || "");
      setActive(organization.active);
      // setAssignedUserEmail(organization.assignedUserEmail || "");
    }
  }, [mode, organization]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const code = organizationCode.trim().toUpperCase();

    // Only letters, numbers and max one dash
    const orgCodeRegex = /^(?!.*-.*-)[A-Z0-9-]/;

    if (!orgCodeRegex.test(code)) {
      showWarning("Organization code can only contain uppercase letters, numbers, and at most one dash");
      return;
    }

    setLoading(true);

    try {
      let orgId;

      if (mode === "create") {
        const response = await api.su_Organiation.createSuOrg({
          name,
          description,
          email,
          active,
          organization_code: code, // UPPERCASE sent
        });

        orgId = response.id;
      } else {
        await api.su_Organiation.updateSuOrgDetails(organization.id, {
          name,
          description,
          email,
          active,
          organization_code: code, // UPPERCASE sent
        });

        orgId = organization.id;
      }

      showSuccess(mode === "create" ? "Organization created successfully" : "Organization updated successfully");

      onClose();
      refreshOrganizations();
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{mode === "create" ? "Create Organization" : "Edit Organization"}</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", width: "500px" }}>

            {/* Name */}
            <SoftBox mb={2}>
              <SoftTypography variant="caption" fontWeight="bold">Organization Name <Box component="span" color="error.main">*</Box></SoftTypography>
              <SoftInput
                type="text"
                placeholder="Enter organization name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </SoftBox>

            {/* Organization Code */}
            <SoftBox mb={2}>
              <SoftTypography variant="caption" fontWeight="bold">Organization Code <Box component="span" color="error.main">*</Box></SoftTypography>
              <SoftInput
                type="text"
                placeholder="Enter organization code(EX. ABC-12, abc-123, ABC123, ABC-1A)"
                inputProps={{ maxLength: 6 }}
                value={organizationCode}
                onChange={(e) => setOrganizationCode(e.target.value.toUpperCase())}
                required
              />
            </SoftBox>

            {/* Description */}
            <SoftBox mb={2}>
              <SoftTypography variant="caption" fontWeight="bold">Description</SoftTypography>
              <SoftInput
                type="text"
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </SoftBox>

            {/* Email */}
            <SoftBox mb={2}>
              <SoftTypography variant="caption" fontWeight="bold">Organiztion Email <Box component="span" color="error.main">*</Box></SoftTypography>
              <SoftInput
                type="email"
                placeholder="Organization email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </SoftBox>
            {/* Assign User Email */}
            {/* {mode === "create" && (
            <SoftBox mb={2}>
              <SoftTypography variant="caption" fontWeight="bold">
                Add User Email
              </SoftTypography>
              <SoftInput
                type="email"
                placeholder="Enter user email to assign to the organiztion as ADMIN"
                value={assignedUserEmail}
                onChange={(e) => setAssignedUserEmail(e.target.value)}
              />
            </SoftBox>
            )} */}
            {/* Active Toggle */}
            {/* {mode === "edit" && (<SoftBox>
              <FormControlLabel
                control={
                  <Switch
                    checked={active}
                    onChange={(e) => setActive(e.target.checked)}
                  />
                }
                label="Active Organization"
              />
            </SoftBox>)} */}

          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          // onClick={handleSubmit}
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

CreateOrganizationPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(["create", "edit"]).isRequired,
  organization: PropTypes.object,
  refreshOrganizations: PropTypes.func.isRequired,
};

export default CreateOrganizationPopup;